import { Controller } from "@hotwired/stimulus";

export class ZipcodeAutofillController extends Controller {
    static targets = ["postalCode", "prefecture", "addressCity", "addressTownAndBuilding"];

    async autofill(event) {
        // イベントリスナーがアタッチされた要素から値を取得
        const inputCode = event.currentTarget.value;

        // 郵便番号の正規化（ハイフン削除＋半角変換＋7桁制限）
        const normalized = this.normalizePostalCode(inputCode);

        // 半角数字7桁かチェック
        const postalCode = /^\d{7}$/.test(normalized) ? normalized : null;
        if (!postalCode) return;

        // 同じフォームセクション内の住所フィールドを取得
        const addressFields = this.findAddressFields(event.currentTarget);
        if (!addressFields) return;

        // Proxyエンドポイント呼び出し
        try {
            const url = `/api/v1/customer/zip_lookup?zipcode=${encodeURIComponent(postalCode)}`;
            const response = await fetch(url, {
                headers: { "Accept": "application/json" },
                credentials: "same-origin",
            });

            let data;
            try {
                data = await response.json();
            } catch (e) { // 障害等でProxyエンドポイントが正常に動いていない場合
                throw new Error(`Invalid JSON response (status: ${response.status})`);
            }

            if (!response.ok || data.error) { // 422 or 502 or 404 error
                console.error("住所取得失敗：", data.error || `HTTP ${response.status}`);
                return;
            }

            // 都道府県欄、市区町村欄、町名・番地・建物名欄の自動入力
            addressFields.prefecture.value = String(data.prefecture_code || "");
            addressFields.addressCity.value = String(data.city || "");
            addressFields.addressTownAndBuilding.value = String(data.town_name || "");

            // 町名・番地・建物名欄にフォーカス移動
            // なお、大口事業所専用郵便番号の場合には町名・番地・建物名欄は空欄のままとなるため、data.cityで判断する
            if (data.city) {
                addressFields.addressTownAndBuilding.focus();
            }
        } catch (error) {
            console.error("API通信エラー：", error);
        }
    }

    normalizePostalCode(str) {
        // ハイフン（半角・全角）を削除 + 全角数字を半角に変換
        const cleaned = str.replace(/[-ー−－―]/g, "").replace(/[０-９]/g, s =>
            String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
        );

        // 7桁を超える場合はカット
        return cleaned.slice(0, 7);
    }

    // 入力フィールドから同じフォームセクション内の住所フィールドを探す
    findAddressFields(postalCodeInput) {
        // ステップ1: フォームコンテナを特定
        // 新規登録: 個人(.profile-fields--individual)または法人(.profile-fields--corporate)
        // 編集画面: form全体
        const container = postalCodeInput.closest('.profile-fields--individual')
                       || postalCodeInput.closest('.profile-fields--corporate')
                       || postalCodeInput.closest('form');

        if (!container) return null;

        // ステップ2: 住所自動入力に必要な3つのフィールドを取得
        const prefecture = this.prefectureTargets.find(el => container.contains(el));
        const addressCity = this.addressCityTargets.find(el => container.contains(el));
        const addressTownAndBuilding = this.addressTownAndBuildingTargets.find(el => container.contains(el));

        // ステップ3: すべてのフィールドが存在する場合のみ成功
        if (!prefecture || !addressCity || !addressTownAndBuilding) return null;

        return { prefecture, addressCity, addressTownAndBuilding };
    }

    adjustPostalCode(event) {
        // イベントリスナーがアタッチされた要素を正規化
        event.currentTarget.value = this.normalizePostalCode(event.currentTarget.value);
    }
}
